define((require) => {
    "use strict";

    var EventDispatcher = require("shared/util/EventDispatcher"),
        Keyboard        = require("services/Keyboard");

    /**
     * The widget grouping event dispatcher singleton.
     *
     * Takes care of detecting the group and ungroup shortcuts, triggering an event when either is
     * detected.
     *
     * @class WidgetGroup
     * @constructor
     */
    var WidgetGroup = EventDispatcher.extend({

        constructor: function() {
            // Add binding for grouping
            Keyboard.Shortcut.bind(["ctrl+g", "meta+g"], () => {
                this.group({eventProperties: {triggerOrigin: "keyboardShortcut"}});
                return false; // Prevent default browser behaviour
            });

            // Add binding for ungrouping
            Keyboard.Shortcut.bind(["shift+ctrl+g", "shift+meta+g"], () => {
                this.ungroup({eventProperties: {triggerOrigin: "keyboardShortcut"}});
                return false; // Prevent default browser behaviour
            });
        },

        /**
         * Trigger event for grouping
         */
        group: function(options) {
            this.trigger("group", options);
        },

        /**
         * Trigger event for ungrouping
         */
        ungroup: function(options) {
            this.trigger("ungroup", options);
        }

    });

    return new WidgetGroup();
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/WidgetGroup.js